import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { MessageService } from 'primeng/api';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient } from '@angular/common/http';
import { OAuthStorage, provideOAuthClient } from 'angular-oauth2-oidc';
import { StorageService } from './core/storage/storage.service';


export const appConfig: ApplicationConfig = {
  providers: [provideRouter(routes), 
              provideAnimations(),
              provideHttpClient(),
              provideOAuthClient(),
              {
                provide: OAuthStorage,
                useClass: StorageService,
              },
              MessageService]      
                                      
};

